import {useCallback} from 'react';
import {
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import {GridDeleteIcon} from '@mui/x-data-grid';
import MsgAddIcon from '../../../../asset/icons/addmsg.svg';
import CreateButton from '../../../../components/Button/CreateButton';
import {IDemoScriptStateProp} from '../../../../dto/demoStingerFulfilment.dto';
type Props = {
  defaultScript: IDemoScriptStateProp[];
  setDefaultScript: React.Dispatch<
    React.SetStateAction<IDemoScriptStateProp[]>
  >;
  handleDelete: (id: number) => void;
  handleAdd: () => void;
};
const DemoStingerScriptSection = ({
  defaultScript,
  setDefaultScript,
  handleDelete,
  handleAdd,
}: Props) => {
  const handleChange = useCallback(
    (id: number, field: 'name' | 'message', value: string) => {
      setDefaultScript(prevState =>
        prevState.map(item =>
          item.id === id ? {...item, [field]: value} : item,
        ),
      );
    },
    [setDefaultScript],
  );
  return (
    <Box className='max-h-500 overflow-auto scrollbar'>
      <Stack
        direction='row'
        alignItems='center'
        justifyContent={'space-between'}
        spacing={2}>
        <Typography variant='h6'>Messages</Typography>
        <CreateButton
          className='float-right mr-10'
          title='Add Message'
          icon={MsgAddIcon}
          onClick={handleAdd}
        />
      </Stack>
      <TableContainer>
        <Table
          sx={{
            '.MuiTableCell-root, .MuiTableRow-root': {
              border: 'none !important',
              padding: '6px 0',
            },
          }}>
          <TableBody>
            {defaultScript &&
              defaultScript.map(item => (
                <TableRow key={item.id}>
                  <TableCell className='text-white-50'>
                    <TextField
                      label='Name'
                      onChange={e =>
                        handleChange(item.id, 'name', e.target.value)
                      }
                      variant='outlined'
                    />
                  </TableCell>
                  <TableCell>
                    <TextField
                      multiline
                      rows={4}
                      style={{width: 500}}
                      value={item.message}
                      onChange={e =>
                        handleChange(item.id, 'message', e.target.value)
                      }
                    />
                  </TableCell>
                  <TableCell>
                    <GridDeleteIcon
                      onClick={() => {
                        handleDelete(item.id);
                      }}
                    />
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export default DemoStingerScriptSection;
